import { TemplateRef } from '@angular/core';
var DwFormItemPanelComponent = /** @class */ (function () {
    function DwFormItemPanelComponent() {
        /* 是否Flex布局  */
        this.dwFlex = false;
        this.dwRequired = false;
        this.dwHasFeedback = false;
        this.validationMessages = [];
    }
    Object.defineProperty(DwFormItemPanelComponent.prototype, "dwLabel", {
        set: function (title) {
            if (title instanceof TemplateRef) {
                this.titleTpl = title;
            }
            else {
                this.titleStr = title;
            }
        },
        enumerable: true,
        configurable: true
    });
    return DwFormItemPanelComponent;
}());
export { DwFormItemPanelComponent };
